import { render, staticRenderFns } from "./DiagnoseRecord.vue?vue&type=template&id=0227b790&scoped=true&"
import script from "./DiagnoseRecord.vue?vue&type=script&lang=js&"
export * from "./DiagnoseRecord.vue?vue&type=script&lang=js&"
import style0 from "./DiagnoseRecord.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DiagnoseRecord.vue?vue&type=style&index=1&id=0227b790&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0227b790",
  null
  
)

export default component.exports